import { API_ENDPOINTS } from '@/api/endpoints.constant';
import { AppConstants } from '@/app.constants';
import { systemConfig } from '@/config/systemConfig';
import { login } from '@/store/slices/authSlice';
import { store } from '@/store/store';
import { clivApiRequest } from '@/utils/apiClient';
import { ClivLoginResponse } from '@/types/ClivLoginResponse.type';

const AUTH_LOG = '[inspect-auth]';

/**
 * If the browser has a valid SSO cookie from another app, exchange it for an inspect session.
 *
 * @see ../../../backend-v2/docs/README-SSO.md
 */
export async function tryInspectSsoSilentLogin(): Promise<void> {
    if (store.getState().auth.token) {
        // eslint-disable-next-line no-console -- login diagnostics
        console.debug(AUTH_LOG, 'tryInspectSsoSilentLogin: skip — already have a token');
        return;
    }
    try {
        // eslint-disable-next-line no-console -- login diagnostics
        console.debug(AUTH_LOG, 'tryInspectSsoSilentLogin: POST /auth/login (credentials: include, no B2C token)', {
            tenantId: systemConfig.tenantId,
            appName: AppConstants.APP_NAME,
            apiUrl: systemConfig.apiUrl,
        });
        const url = `${systemConfig.apiUrl}/${API_ENDPOINTS.AUTH.LOGIN}`;
        const response = await clivApiRequest<ClivLoginResponse>(
            {
                url,
                method: 'POST',
                body: {
                    tenantId: systemConfig.tenantId,
                    appName: AppConstants.APP_NAME,
                },
            },
            true,
        );
        // eslint-disable-next-line no-console -- login diagnostics
        console.debug(AUTH_LOG, 'tryInspectSsoSilentLogin: response', {
            ok: response.ok,
            status: response.status,
            requestId: response.requestId,
            hasAccessToken: Boolean(response.data?.accessToken),
            hasUser: Boolean(response.data?.user),
        });
        if (response.ok && response.data?.accessToken && response.data.user) {
            // eslint-disable-next-line no-console -- login diagnostics
            console.debug(AUTH_LOG, 'tryInspectSsoSilentLogin: dispatch login()', {
                userId: response.data.user.id,
                email: response.data.user.email,
            });
            store.dispatch(
                login({
                    token: response.data.accessToken,
                    user: response.data.user,
                }),
            );
        } else {
            // eslint-disable-next-line no-console -- login diagnostics
            console.debug(AUTH_LOG, 'tryInspectSsoSilentLogin: no session (SSO cookie missing, invalid, or user not allowed)');
        }
    } catch (error) {
        // eslint-disable-next-line no-console -- login diagnostics
        console.debug(AUTH_LOG, 'tryInspectSsoSilentLogin: silent SSO attempt failed', error);
    }
}
